module.exports = __webpack_public_path__ + "static/img/NavBar_BG@3x.42ef509.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NavBar_BG@3x.png
// module id = 3AsL
// module chunks = 1